import React from "react";
import "../DeleteDialog/deleteDialog.scss";
import { useTranslation } from "react-i18next";

export default function ClearFormConfirm({ onConfirm, onClose }) {
    const { t } = useTranslation();

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <div className="confirm__wrapper">
            <ul className="confirm__list">
                <li className="confirm__item">
                    <h2 className="confirm__title title--yellow">{t("clearForm.title")}</h2>
                </li>
                <li className="confirm__item">
                    <p className="confirm__option">
                        {t("clearForm.message")}
                    </p>
                </li>
                <li className="confirm__item">
                    <button
                        className="popup__button"
                        type="button"
                        onClick={handleConfirm}
                    >
                        {t("clearForm.yes")}
                    </button>
                    <button
                        className="popup__button popup__button--cancel"
                        type="button"
                        onClick={onClose}
                    >
                        {t("clearForm.no")}
                    </button>
                </li>
            </ul>
            <button
                className="popup__close-button payment-confirm__close-button"
                type="button"
                onClick={onClose}
            />
        </div>
    );
}
